import type { ReactNode } from 'react';
import { CountdownRing } from './countdown-ring';

/**
 * Warm QR mount. Wraps a real QR (qrcode.react `QRCodeSVG` or the metro
 * `DynamicQRCode`) in the paper frame; `live` overlays the depleting ring that
 * signals the metro dynamic QR is auto-refreshing.
 */
export function QrFrame({
  children,
  live,
  refreshSeconds = 30,
  style,
}: {
  children: ReactNode;
  live?: boolean;
  refreshSeconds?: number;
  style?: React.CSSProperties;
}) {
  return (
    <div className="wb-qr-frame" style={style}>
      {children}
      {live && (
        <span className="wb-live-ring">
          <CountdownRing seconds={refreshSeconds} />
        </span>
      )}
    </div>
  );
}
